import React from "react";
import {Box, Tooltip} from "@mui/material";

export default function TooltipLabel({label}) {

    return (
      <Tooltip title={label}>
          <Box>{label}</Box>
      </Tooltip>
    );
}
